export default __webpack_public_path__ + "static/media/In_progress.fc248598.svg";